import type { Ref } from 'react';

interface ProgressBarProps {
  chapterNum: number;
  totalChapters: number;
  chapterLabel: string;
  onToggleNav: () => void;
  navToggleRef?: Ref<HTMLButtonElement>;
}

// Barra de progreso dorada · "Capítulo X de Y" (handoff §11).
export function ProgressBar({
  chapterNum,
  totalChapters,
  chapterLabel,
  onToggleNav,
  navToggleRef,
}: ProgressBarProps) {
  const pct = Math.max(4, Math.round((chapterNum / totalChapters) * 100));
  return (
    <header className="gb-progress" role="banner">
      <div
        className="gb-progress__rail"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={totalChapters}
        aria-valuenow={chapterNum}
        aria-label={`Capítulo ${chapterNum} de ${totalChapters}`}
      >
        <div className="gb-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="gb-progress__meta">
        <button
          ref={navToggleRef}
          type="button"
          className="gb-navtoggle"
          onClick={onToggleNav}
          aria-haspopup="dialog"
          aria-label="Ver capítulos y avance"
        >
          <span aria-hidden="true">☰</span>
        </button>
        <span className="gb-progress__brand">GBCMC</span>
        <span className="gb-progress__label">
          Capítulo {chapterNum} de {totalChapters} · {chapterLabel}
        </span>
      </div>
    </header>
  );
}
